module.exports = __webpack_public_path__ + "static/img/9.3407096.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/9.png
// module id = QW6+
// module chunks = 0